import { AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

import { Directive } from '@angular/core';

export enum CustomValidatorErrors {
  validateEmail = 'validateEmail',
}

export const VALIDATE_EMAIL_REGEXP: RegExp =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(?:\.(?:)[a-zA-Z0-9]{1,61})$/;

export function plValidateEmail(c: AbstractControl): ValidationErrors | null {
  const formControlValue: string = c.value;

  if (!formControlValue) {
    return null;
  }

  return VALIDATE_EMAIL_REGEXP.test(formControlValue)
    ? null
    : {
        [CustomValidatorErrors.validateEmail]: true,
      };
}

@Directive({
  selector: '[plValidateEmail][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useValue: plValidateEmail, multi: true }],
})
export class EmailValidatorDirective {}
